import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Device from '../../../../../shared/components/global/Device/Device';
import StyledLink from '../../../../../shared/components/global/StyledLink';
import JobCard from '../../../../../shared/components/job/JobCard';
import { CareerLevel } from '../../../../../shared/model/CareerLevel';
import { Categories } from '../../../../../shared/model/Categories';
import { EmploymentType } from '../../../../../shared/model/EmploymentType';
import { RemoteType } from '../../../../../shared/model/RemoteType';
import { Container, ContainerContentFull, ContainerContentStandard } from '../../../../../shared/styles/container';
import { device } from '../../../../../shared/styles/device';
import Layout from '../../../components/global/Layout';
import Seo from '../../../components/global/Seo';
import JobsFilter from '../../../components/jobs/JobsFilter';
import JobsHeroHeader from '../../../components/jobs/JobsHeroHeader';
import JobsPagination from '../../../components/jobs/JobsPagination';
import JobsSearchbar from '../../../components/jobs/JobsSearchbar';
import { BUCKET_URL } from '../../../model/S3Bucket';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchJobsSearchAsync, JobsOperation, selectJobsSearchJobs, selectJobsSearchNextToken, selectJobsSearchPrevTokens, selectJobsSearchSearchAggregates, selectJobsSearchTotal } from '../../../redux/jobsSearchSlice';

const JobsResult = styled.article`
    padding-top: 16px;
    padding-bottom: 32px;
    min-height: 100vh;
    h1 {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        margin-bottom: 0;
    }
`;

const JobsResultGrid = styled.div`
    margin-top: 32px;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
    height: 100%;
    width: 100%;
    position: relative;
    grid-gap: 32px;

    @media ${device.tablet} { 
        grid-template-columns: 200px auto;
        grid-gap: 64px;
        margin-top: 48px;
    }
`;

const JobCardList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .job-card {
        margin-bottom: 32px;
    }
`;

const SearchbarOuterContainer = styled.div`
  position: relative;
  margin-bottom: 0px;
  margin-top: 24px;

    @media ${device.tablet} { 
     margin-bottom: 30px;
     margin-top: 0;
    }
`;

const SearchPage = () => {

    const JOBS_PER_PAGE = 15;

    const [filters, setFilters] = useState<any>();

    const total = useAppSelector(selectJobsSearchTotal);
    const jobs = useAppSelector(selectJobsSearchJobs);
    const searchAggregates = useAppSelector(selectJobsSearchSearchAggregates);
    const nextToken = useAppSelector(selectJobsSearchNextToken)
    const previousTokens = useAppSelector(selectJobsSearchPrevTokens)

    const dispatch = useAppDispatch()
    const router = useRouter()

    const fetchData = async (token, filters, operation) => {
        const filter = {};
        const filterAnd: any[] = [];

        const nowISODate = new Date().toISOString();

        filter['expiresAt'] = { gte: nowISODate }
        if (filters.where != null && filters.where?.length > 0) filter['city'] = { matchPhrasePrefix: filters.where }
        if (filters.what != null && filters.what?.length > 0) {
            const newOr: any = [];
            newOr.push({ title: { matchPhrasePrefix: filters.what } })
            newOr.push({ category: { matchPhrasePrefix: filters.what } })
            newOr.push({ description: { matchPhrasePrefix: filters.what } })
            filterAnd.push({ or: newOr });
        }
        if (filters.categories != null && filters.categories?.length > 0) {
            const newOr: any = [];
            const categoriesArray = filters.categories.split(',');
            categoriesArray.forEach((category) => newOr.push({ category: { matchPhrase: Categories[category] } }))
            filterAnd.push({ or: newOr });
        }
        if (filters.careerLevel != null && filters.careerLevel?.length > 0) {
            const newOr: any = [];
            const categoriesArray = filters.careerLevel.split(',');
            categoriesArray.forEach((category) => newOr.push({ careerLevel: { matchPhrase: CareerLevel[category] } }))
            filterAnd.push({ or: newOr });
        }
        if (filters.employmentType != null && filters.employmentType?.length > 0) {
            const newOr: any = [];
            const categoriesArray = filters.employmentType.split(',');
            categoriesArray.forEach((category) => newOr.push({ employmentType: { matchPhrase: EmploymentType[category] } }))
            filterAnd.push({ or: newOr });
        }
        if (filters.remoteType != null && filters.remoteType?.length > 0) {
            const newOr: any = [];
            const categoriesArray = filters.remoteType.split(',');
            categoriesArray.forEach((category) => newOr.push({ remoteType: { matchPhrase: RemoteType[category] } }))
            filterAnd.push({ or: newOr });
        }

        const variables = {
            nextToken: token,
            limit: JOBS_PER_PAGE,
            aggregates: buildSearchAggregatesFilter(),
            filter: filter,
            operation: operation
        };
        if (filterAnd.length > 0) {
            variables.filter['and'] = filterAnd;
        }

        await dispatch(fetchJobsSearchAsync(variables));
    }

    const buildSearchAggregatesFilter = () => {
        const aggregates: any[] = [];
        aggregates.push({
            field: "category",
            name: "category",
            type: "terms",
        });
        aggregates.push({
            field: "careerLevel",
            name: "careerLevel",
            type: "terms",
        });
        aggregates.push({
            field: "employmentType",
            name: "employmentType",
            type: "terms",
        });
        aggregates.push({
            field: "remoteType",
            name: "remoteType",
            type: "terms",
        });
        return aggregates;
    }

    useEffect(() => {
        const filters = loadFiltersFromParams();
        fetchData(null, filters, JobsOperation.INITIAL);
    }, [router])

    const loadFiltersFromParams = () => {
        let searchParams = new URLSearchParams(window.location.search);
        const searchParamsWhat: any = searchParams?.get('what');
        const searchParamsWhere: any = searchParams?.get('where');
        const searchParamsCategories: any = searchParams?.get('categories');
        const searchParamsCareerLevel: any = searchParams?.get('careerLevel');
        const searchParamseEmploymentType: any = searchParams?.get('employmentType');
        const searchParamsRemoteType: any = searchParams?.get('remoteType');
        const filters = {
            what: searchParamsWhat,
            where: searchParamsWhere,
            categories: searchParamsCategories,
            careerLevel: searchParamsCareerLevel,
            employmentType: searchParamseEmploymentType,
            remoteType: searchParamsRemoteType,
        }
        setFilters(searchParamsWhat);
        return filters;
    }

    const pageBack = () => {
        const filters = loadFiltersFromParams();
        fetchData(previousTokens[previousTokens.length - 1], filters, JobsOperation.PREV).then(() => {
            if (typeof window != 'undefined') {
                window.scrollTo(0, 0)
            }
        });
    }

    const pageNext = () => {
        const filters = loadFiltersFromParams();
        fetchData(nextToken, filters, JobsOperation.NEXT).then(() => {
            if (typeof window != 'undefined') {
                window.scrollTo(0, 0)
            }
        });
    }

    const noItemsOnLastPage = (): boolean => {
        if (jobs != null && total != null && jobs.length === total) {
            return true;
        }
        if (previousTokens?.length != null && jobs != null) {
            if (previousTokens.length * JOBS_PER_PAGE + jobs.length === total) {
                return true;
            }
        }
        return false;
    }

    const title = 'Jobs entdecken | STELL-MICH-EIN';
    const description = 'Entdecke die Jobs vom STELL-MICH-EIN';
    return (
        <>
            <Seo title={title} description={description} />
            <Layout preview={false}>
                <Device>
                    {({ isMobile }) => !isMobile && (
                        <Container backgroundColor='#FAFAFA'>
                            <ContainerContentFull>
                                <JobsHeroHeader small />
                            </ContainerContentFull>
                        </Container>)
                    }
                </Device>
                <Container backgroundColor='#f5f5f7'>

                    <ContainerContentStandard>
                        <SearchbarOuterContainer>
                            <JobsSearchbar top={"-30px"} />
                        </SearchbarOuterContainer>
                        <JobsResult>
                            <h1>{total} Treffer {filters?.what?.length > 0 && `für ${filters?.what}`} {filters?.where?.length > 0 && `in ${filters?.where}`}</h1>
                            <JobsResultGrid>
                                <JobsFilter searchAggregates={searchAggregates} />
                                {jobs != null && jobs?.length > 0 &&
                                    <div>
                                        <JobCardList>
                                            {jobs?.map((job, index) => {
                                                return (
                                                    <StyledLink key={job?.title + index} href={`/jobs/${job.slug}`}>
                                                        <JobCard job={job} smallCard={false} bucketUrl={BUCKET_URL} />
                                                    </StyledLink>
                                                )
                                            })}
                                        </JobCardList>
                                        <JobsPagination
                                            prevDisabled={previousTokens?.length < 1}
                                            nextDisabled={nextToken == null || noItemsOnLastPage()}
                                            pageBack={() => pageBack()}
                                            pageNext={() => pageNext()}
                                        />
                                    </div>
                                }
                            </JobsResultGrid>
                        </JobsResult>
                    </ContainerContentStandard>
                </Container>
            </Layout>
        </>
    )
}

export default SearchPage;